import { gql } from '@apollo/client'

export const CONTACT_FROM = gql`
    mutation ContactForm($name: String!, $email: String!, $message: String!, $consent: Boolean!) {
  contactForm(name: $name, email: $email, message: $message, consent: $consent) {
    message
  }
}`
